import React, { useRef, useState, useEffect } from 'react';
import {Box, Button, LinearProgress, Modal, Typography, Link} from '@mui/material';
import { Close, FiberManualRecord, Stop } from '@mui/icons-material';
import { Slide } from '../services/types';
import {uploadVideoWEBM} from "../services/api";


interface SingleRecordingEditorProps {
    slide: Slide;
    closeRecording: () => void;
}

var intervalELement: any
var iteration: number = 0

const SingleRecordingEditor: React.FC<SingleRecordingEditorProps> = ({ slide, closeRecording }) => {
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const [recording, setRecording] = useState(false);
    const [videoUrl, setVideoUrl] = useState<string | null>(null);
    const [leftPos, setLeftPos] = useState<number>(0);
    const [slideNumber, setSlideNumber] = useState<number>(0);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [videoBlob, setVideoBlob] = useState<Blob | null>(null);
    const [videoLink, setVideoLink] = useState<string>('');
    const [slideData, setSlideData] = useState<Slide>(null);
    // @ts-ignore
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    // const animationRef = useRef<number>(0);
    const startTimeRef = useRef<number>(0);
    const iterationRef = useRef<number>(0);
    const slideNumberRef = useRef<number>(0);

    // Храним чанки видео
    const chunksRef = useRef<Blob[]>([]);



    // Начать запись
    const startRecording = async () => {

        try {
            const stream = await navigator.mediaDevices.getDisplayMedia({
                video: { displaySurface: "browser" },
                preferCurrentTab: true
            } as any);

            // Проверка треков
            if (stream.getVideoTracks().length === 0) {
                alert('Запись отменена: не выбрана область!');
                return;
            }



            chunksRef.current = [];
            const mediaRecorder = new MediaRecorder(stream, {
                mimeType: 'video/webm; codecs=vp9' // Явное указание кодека
            });

            mediaRecorder.ondataavailable = (e) => {
                if (e.data.size > 0) chunksRef.current.push(e.data);
            };

            mediaRecorder.onstop = () => {
                const blob = new Blob(chunksRef.current, { type: 'video/webm' });
                if (blob.size === 0) {
                    alert('Ошибка: записанный файл пуст!');
                    return;
                }
                setVideoUrl(URL.createObjectURL(blob));
                setVideoBlob(blob); // Сохраняем blob
                stream.getTracks().forEach(track => track.stop());
            };

            mediaRecorderRef.current = mediaRecorder;
            mediaRecorder.start(1000); // Запись чанков каждую секунду
            setRecording(true);

            timerRef.current = setTimeout(() => {
                console.log(222)
                stopRecording();
            }, slide.duration*1000);

        } catch (err) {
            alert('Ошибка: ' + (err as Error).message);
        }
    };

    const stopRecording = () => {
        // if (mediaRecorderRef.current && recording) {
        // }
        if (timerRef.current) {
            setTimeout(() => {
                mediaRecorderRef.current?.stop();
            }, 1000); // Задержка для завершения записи
            setRecording(false);
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    useEffect(() => {
        let slideD: Slide = slide;
        slideD.html = slideD.html.replace("<body", "<body style='cursor:none;'");
        setSlideData(slideD)
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);
    useEffect(() => {
        saveVideo()
    }, [videoBlob]);


    // Сохранить видео
    const saveVideo = async () => {
        if (videoBlob) {
            setIsUploadModalOpen(true);
            try {
                const file = new File([videoBlob], "recording.webm", { type: "video/webm" });
                const response = await uploadVideoWEBM(file, null, slide!.id, (progress) => {
                    setUploadProgress(progress);
                });
                setVideoLink(response)
            } catch (error) {
                console.error('Error uploading video:', error);
            } finally {
                setIsUploadModalOpen(false);
                setUploadProgress(0);
            }

        }
    };

    return (
        <Box className="recordingView">
            <Box className="iframeBox" style={{ cursor: "none" }}>
                <Box className="iframeBoxList" style={{left: leftPos+"%" }}>
                    <iframe
                        // ref={iframeRef}
                        allow="cross-origin-isolated; display-capture"
                        sandbox="allow-same-origin allow-scripts"
                        srcDoc={slideData?.html}
                        style={{
                            width: '100%',
                            height: '100%',
                            // pointerEvents: 'none'
                        }}
                        title={slide?.name}
                    />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                {!recording && (
                    <Button
                        variant="contained"
                        color="error"
                        onClick={startRecording}
                        startIcon={<FiberManualRecord />}
                    >
                        Начать запись
                    </Button>
                )}
                {recording && (
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={stopRecording}
                        startIcon={<Stop />}
                    >
                        Остановить запись
                    </Button>
                )}
                <Button className="closeRecording" onClick={closeRecording}><Close></Close></Button>
            </Box>
            {/*{videoLink!=='' && (*/}
            {/*    <Box sx={{ mt: 2 }}>*/}
            {/*        <a href={videoLink} target='_blank' style={{margin:0, padding: 0}}>*/}
            {/*            <Button variant="outlined" sx={{ mt: 1 }}>*/}
            {/*                Открыть*/}
            {/*            </Button>*/}
            {/*        </a>*/}
            {/*    </Box>*/}
            {/*)}*/}
            {/* Модальные окна */}
            <Modal open={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        {uploadProgress < 100 ?
                            <Box sx={{ /* стили */}}>
                                <Typography sx={{mb: 3}}>Пожалуйста, дождитесь завершения загрузки</Typography>
                                <LinearProgress variant="determinate" value={uploadProgress}/>
                                <Typography>{uploadProgress}%</Typography>
                            </Box>
                            :
                            <Box sx={{ /* стили */}}>
                                <Typography>Видео конвертируется</Typography>
                            </Box>
                        }
                    </Box>
                </Box>
            </Modal>

        </Box>
    );
};

export default SingleRecordingEditor;
